/**
 * 위례 소년소녀 합창단 소개 페이지
 */

import React from 'react';
import styled from '@emotion/styled';
import { MainLayout } from '../../../../shared/components';
import { theme } from '../../../../shared/styles/theme';
import { mediaQueries } from '../../../../shared/constants/breakpoints';

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${theme.spacing.xxxl} ${theme.spacing.lg};

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.xl} ${theme.spacing.md};
  }
`;

const PageTitle = styled.h1`
  font-size: ${theme.fontSizes.xxxl};
  font-weight: 700;
  color: ${theme.colors.primary};
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
  font-family: ${theme.fonts.heading};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xxl};
  }
`;

const ImagePlaceholder = styled.div`
  width: 100%;
  max-width: 800px;
  height: 400px;
  margin: 0 auto ${theme.spacing.xl};
  background-color: ${theme.colors.border};
  border-radius: ${theme.borderRadius.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.textLight};
  font-size: ${theme.fontSizes.lg};

  ${mediaQueries.maxMobile} {
    height: 250px;
  }
`;

const Section = styled.section`
  margin-bottom: ${theme.spacing.xxxl};
`;

const SectionTitle = styled.h2`
  font-size: ${theme.fontSizes.xxl};
  font-weight: 700;
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.lg};
  font-family: ${theme.fonts.heading};
  border-bottom: 3px solid ${theme.colors.primary};
  padding-bottom: ${theme.spacing.md};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xl};
  }
`;

const ContentText = styled.p`
  font-size: ${theme.fontSizes.lg};
  line-height: 1.8;
  color: ${theme.colors.text};
  margin-bottom: ${theme.spacing.lg};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.md};
  }
`;

const VisionBox = styled.div`
  background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.secondary} 100%);
  color: white;
  padding: ${theme.spacing.xxl};
  border-radius: ${theme.borderRadius.lg};
  text-align: center;
  box-shadow: ${theme.shadows.md};

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.xl} ${theme.spacing.lg};
  }
`;

const VisionText = styled.p`
  font-size: ${theme.fontSizes.xl};
  line-height: 1.8;
  margin: 0;

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.lg};
  }
`;

const InfoCard = styled.div`
  background-color: ${theme.colors.hover};
  padding: ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.md};
  margin-bottom: ${theme.spacing.lg};
`;

const InfoLabel = styled.p`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.textLight};
  margin-bottom: ${theme.spacing.sm};
  font-weight: 600;
`;

const InfoValue = styled.p`
  font-size: ${theme.fontSizes.lg};
  color: ${theme.colors.primary};
  font-weight: 700;
  margin: 0;
`;

export const WiryeChoir: React.FC = () => {
  return (
    <MainLayout>
      <PageContainer>
        <PageTitle>위례 소년소녀 합창단</PageTitle>

        <ImagePlaceholder>이미지 영역</ImagePlaceholder>

        <Section>
          <SectionTitle>비전</SectionTitle>
          <VisionBox>
            <VisionText>
              어린이들이 찬양을 통해 하나님을 경배하고, 재능을 개발하며 성장하는 합창단입니다.
            </VisionText>
          </VisionBox>
        </Section>

        <Section>
          <SectionTitle>소개</SectionTitle>
          <ContentText>
            위례 소년소녀 합창단은 교회학교 어린이들로 구성된 합창단으로,
            주일 예배와 특별 행사에서 찬양을 통해 하나님께 영광을 돌립니다.
            어린이들의 재능을 개발하고 신앙 안에서 성장할 수 있도록 돕고 있습니다.
          </ContentText>
        </Section>

        <Section>
          <SectionTitle>활동 시간</SectionTitle>
          <InfoCard>
            <InfoLabel>연습 시간</InfoLabel>
            <InfoValue>매주 주일 오전 10:30</InfoValue>
          </InfoCard>
        </Section>
      </PageContainer>
    </MainLayout>
  );
};
